import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getAgencies, getLatestAgency, deleteAuthToken, notifySuccess } from '../../utils/helper'
import { setUserInformation, removeUserInformation } from '../../_store/reducers/userReducer'
import styles from '../../_css/Header.module.css'
import { setAgency, getBrandList, getProjectsList, getUserInfo, getSimulationsList, getPricingCreditBalance } from '../../requests'
import BreadcrumbDropdown from './BreadcrumbDropdown'
import getRole from '../../hooks/getRole'
import { clearContext, setContext } from '../../_store/reducers/contextReducer'
import { ADMIN_TABS } from '../Pricing/mockData'
import { ShieldCheck, UserCircle, LogOut } from 'lucide-react'


// const userMenu = [
//   { id: 'brands', icon: <Building2Icon size={12} />, label: 'Brands', path: '/brands' },
//   { id: 'users', icon: <UsersIcon size={12} />, label: 'Users', path: '/invite' },
//   { id: 'profile', icon: <UserIcon size={12} />, label: 'Profile', path: '/profile' },
// ]

// const adminMenu = [
//   { id: 'agencies', label: 'Agencies', icon: '◉', path: '/', primary: true },
// ]

const Header = () => {
  const role = getRole()
  const user = useSelector((state) => state.user)
  const refresh = useSelector((state) => state.refresh)
  const breadcrumb = useSelector((state) => state.context)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const location = useLocation()
  const [showUserMenu, setShowUserMenu] = useState(false)
  const userMenuRef = useRef(null)
  const userInfo = useSelector((state) => state.user);
  const [prevData, setPrevData] = useState(null)
  const [creditUsed, setCreditUsed] = useState(null)
  const [creditIncluded, setCreditIncluded] = useState(null)
  const [creditTopup, setCreditTopup] = useState(null)
  const [creditBalanceLoading, setCreditBalanceLoading] = useState(false)
  const [creditTierUnlimited, setCreditTierUnlimited] = useState(false)

 
  ////////////////////BREADCRUMB Navigation ///////////////////////////////////////////////////////////////

  const prevDataofUser = async () => {
    try {

     if(user?.agency_name && user?.agencyId){
      return { agency: { name: user?.agency_name, id: user?.agencyId } }
     }
      
      const response = await getUserInfo()
      if (response?.status < 400) {
        setPrevData(response?.data)
        return { agency: response?.data?.agency }
      }
      
    } catch (error) {
      console.error('Failed to fetch previous data of user', error)
      return { agency: null }
      
    }
  }

  const fetchCreditBalance = async () => {
    try {
      setCreditBalanceLoading(true)
      const response = await getPricingCreditBalance()
      if (response?.status < 400) {
        const payload = response?.data
        const data = payload?.data ?? payload
        const used = data?.used_credits ?? data?.usedCredits ?? null
        const included = data?.max_credits ?? data?.maxCredits ?? data?.included_credits ?? data?.includedCredits ?? null
        const topup = data?.topup_credits ?? data?.topupCredits ?? null
        setCreditUsed(used)
        setCreditIncluded(included)
        setCreditTopup(topup)
        setCreditTierUnlimited(data?.tier === 'U')
      }
    } catch (error) {
      console.error('Failed to fetch credit balance', error)
      setCreditUsed(null)
      setCreditIncluded(null)
      setCreditTopup(null)
      setCreditTierUnlimited(false)
    } finally {
      setCreditBalanceLoading(false)
    }
  }



  // Agencies Dropdown
  const [agencyId, setAgencyId] = useState(user?.agencyId ?? prevData?.agency?.id ?? null)
  const [selectedAgency, setSelectedAgency] = useState(user?.agency_name ?? prevData?.agency?.name ?? "")
  const [agencies, setAgencies] = useState([])

   // Brand Dropdown
   const [brands, setBrands] = useState([])
   const [selectedBrand, setSelectedBrand] = useState(breadcrumb?.brand_name ?? "")
   const [brandId, setBrandId] = useState(breadcrumb?.brand_id ?? null)

   // projects Dropdown
   const [projects, setProjects] = useState([])
   const [selectedProject, setSelectedProject] = useState(breadcrumb?.project_name ?? "")
   const [projectId, setProjectId] = useState(breadcrumb?.project_id ?? null)

   //simulations Dropdown
   const [simulations, setSimulations] = useState([])
   const [selectedSimulation, setSelectedSimulation] = useState(breadcrumb?.simulation_name ?? "")
   const [simulationId, setSimulationId] = useState(breadcrumb?.simulation_id ?? null)


   const fetchAgencies = async () => {
    try {
      const agencies = await getAgencies()
     
      if (agencies && Array.isArray(agencies) && agencies?.length > 0) {
        setAgencies(agencies)
      }
      
    } catch (error) {
      console.error('Failed to fetch agencies', error)
      setAgencies([])
      
    }
   }
   useEffect(() => {
    setSelectedAgency(user?.agency_name ?? "")
    setAgencyId(user?.agencyId ?? null)

    if(role === 'super_admin') {
      fetchAgencies()
    }

   }, [refresh,breadcrumb])

   useEffect(() => {
    setSelectedBrand(breadcrumb?.brand_name ?? "")
    setBrandId(breadcrumb?.brand_id ?? null)

    setSelectedProject(breadcrumb?.project_name ?? "")
    setProjectId(breadcrumb?.project_id ?? null)

    setSelectedSimulation(breadcrumb?.simulation_name ?? "")
    setSimulationId(breadcrumb?.simulation_id ?? null)
   }, [refresh,breadcrumb])

   useEffect(() => {
    fetchCreditBalance()
   }, [refresh])



 



//reset all dropdowns
   const resetAll = () =>{
    dispatch(clearContext())
    setBrandId(null)
    setSelectedBrand("")
    setBrands([])

    setProjectId(null)
    setSelectedProject("")
    setProjects([])
    
    setSimulationId(null)
    setSelectedSimulation("")
    setSimulations([])
    
   }
   // Agency Dropdown
  const setAgencyforSuperAdmin = async (agency) => {
    if (!agency) return
    if (!agency) return
    try {
      const response = await setAgency(Number(agency.id))
      if (response?.status < 400) {
        dispatch(setUserInformation(user.fullName, user.userId, user.email, user.status, user.isSuperAdmin, agency.id, user.invitedById, agency.name, agency.email, user.role))
      }
    } catch (error) {
      console.error('Failed to set agency', error)
    }
  }

  useEffect(() => {
    const fetchLatestAgency = async () => {
      if (role === 'user' || role === 'admin') {
        return;
      }      
      const { agency } = await prevDataofUser()
      if(!agency?.id){
        const latestAgency = await getLatestAgency();
        await setAgencyforSuperAdmin(latestAgency)
        setAgencyId(latestAgency?.id)
        setSelectedAgency(latestAgency?.name)
      }else{
        await setAgencyforSuperAdmin(agency)
        setAgencyId(agency?.id)
        setSelectedAgency(agency?.name)
      }
      
      const agencies = await getAgencies()
      if (agencies && Array.isArray(agencies) && agencies?.length > 0) {
        setAgencies(agencies)
      }
    }

    if (!user?.agencyId || !user?.agency_name) {
      fetchLatestAgency();
    }

  }, [])

  const onChangeAgency = async (val) => {
    if (!val?.id) return
    resetAll()
    await setAgencyforSuperAdmin(val)
    setAgencyId(val.id)
    setSelectedAgency(val?.name)
    
    //agency id only if user is super admin
    if(role === 'super_admin') {
      navigate(`/brands?agency_id=${val.id}`)
    } else {
      navigate(`/brands`)
    }
  }


  // Brand Dropdown
  const resetBrand = () => {
    setProjectId(null)
    setSelectedProject("")
    setProjects([])
  }

  const onChangeBrand = async (val) => {
    resetBrand()
    if (!val) return
    if (!val.id) return
    setBrandId(val?.id)
    setSelectedBrand(val?.name)

    const payload = {
      brand_id: val?.id,
      brand_name: val?.name ?? "",
    }
    dispatch(setContext(payload))

    //agency id only if user is super admin
    if(role === 'super_admin') {
      navigate(`/projects?brand_id=${val.id}&agency_id=${agencyId}`)
    } else {
      navigate(`/projects?brand_id=${val.id}`)
    }
  }

  const fetchBrands = async () => {
    try {
      const brands = await getBrandList()
      if (brands?.status < 400) {
        setBrands(brands?.data ?? [])
      }
    } catch (error) {
      console.error('Failed to fetch brands', error)
      setBrands([])
    }
  }

  useEffect(() => {
    if(!agencyId) return
    fetchBrands()
  }, [agencyId,refresh,breadcrumb])

  //Projects Dropdown
  const resetProject = () => {
    setSimulationId(null)
    setSelectedSimulation("")
    setSimulations([])
    
  }
  const onChangeProject = async (val) => {
    if (!val) return
    if (!val.id) return
    setProjectId(val?.id)
    setSelectedProject(val?.name)
    resetProject()

    const payload = {
      brand_id: breadcrumb?.brand_id ?? null,
      brand_name: breadcrumb?.brand_name ?? "",
      project_id: val?.id,
      project_name: val?.name ?? "",
    }
    dispatch(setContext(payload))
    
    //agency id only if user is super admin
    if(role === 'super_admin') {
      navigate(`/simulations?project_id=${val.id}&brand_id=${brandId}&agency_id=${agencyId}`)
    } else {
      navigate(`/simulations?project_id=${val.id}&brand_id=${brandId}`)
    }
  }

  const fetchProjects = async () => {
    try {
      const projects = await getProjectsList({ brand_id: brandId })
      if (projects?.status < 400) {
        setProjects(projects?.data ?? [])
      }
    } catch (error) {
      console.error('Failed to fetch projects', error)
      setProjects([])
      
    }
  }

  useEffect(() => {
    if(!brandId) return
    fetchProjects()
  }, [brandId,refresh,breadcrumb])

  //Simulation Dropdown
  const fetchSimulations = async () => {
    try {
      const simulations = await getSimulationsList({ project_id: projectId })
      if (simulations?.status < 400) {
       setSimulations(simulations?.data.aiSimulations ?? [])
      }
      
    } catch (error) {
      console.error('Failed to fetch simulations', error)
      setSimulations([])
      
    }
  }
  const onChangeSimulation = async (val) => {
    if (!val) return
    if (!val.id) return
    setSimulationId(val?.id)
    setSelectedSimulation(val?.name)

    //store simulation id in context store
    const payload = {
      brand_id: breadcrumb?.brand_id ?? null,
      brand_name: breadcrumb?.brand_name ?? "",
      project_id: projectId,
      project_name: breadcrumb?.project_name ?? "",
      simulation_id: val?.id,
      simulation_name: val?.name ?? "",
    }
    dispatch(setContext(payload))

    //agency id only if user is super admin
    if(role === 'super_admin') {
      navigate(`/simulations/details/${val?.id}/persona?simulation_id=${val?.id}&project_id=${projectId}&brand_id=${brandId}&agency_id=${agencyId}`)
    } else {
      navigate(`/simulations/details/${val?.id}/persona?simulation_id=${val?.id}&project_id=${projectId}&brand_id=${brandId}`)
    }
  }
  useEffect(() => {
    if(!projectId) return
    fetchSimulations()
  }, [projectId,refresh,breadcrumb])


  const userInitials = userInfo?.fullName?.split(' ').map(name => name[0]).join('')
  const isPricingRoute = location.pathname.startsWith('/pricing')
  const pricingTabLabel =
    ADMIN_TABS.find((tab) => location.pathname.startsWith(tab.path))?.label || 'Rate card'

  useEffect(() => {
    if (!showUserMenu) return undefined
    const closeMenu = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setShowUserMenu(false)
      }
    }
    document.addEventListener('click', closeMenu)
    return () => document.removeEventListener('click', closeMenu)
  }, [showUserMenu])

  const handleLogout = () => {
    setShowUserMenu(false)
    deleteAuthToken()
    dispatch(removeUserInformation())
    dispatch(clearContext())
    navigate('/login')
    notifySuccess('Logged out successfully')
  }

  const openAdmin = () => {
    setShowUserMenu(false)
    navigate('/pricing/rate-card')
  }

  const openProfile = () => {
    setShowUserMenu(false)
    navigate('/profile')
  }

  const toggleUserMenu = (e) => {
    e.stopPropagation()
    setShowUserMenu((prev) => !prev)
  }

  return (
    <div className={`dm-sans-100 ${styles.header}`}>
      <div className={styles.headerLeft}>
        {isPricingRoute ? (
          <div className={styles.pricingCrumbs}>
            <span>Admin</span>
            <span className={styles.crumbSep}>/</span>
            <b>{pricingTabLabel}</b>
          </div>
        ) : (
          <>
        {role === 'super_admin' && <BreadcrumbDropdown value={agencyId} name={selectedAgency} onChange={onChangeAgency} options={agencies} searchPlaceholder="Search Agency..." /> }
        {
          <>
            {role === 'super_admin' &&  <span style={{ color:"rgba(255,255,255,0.28)", fontSize:14, margin:"0 2px" }}>/</span>}
            <BreadcrumbDropdown value={brandId} name={selectedBrand} onChange={onChangeBrand} options={brands} placeholder="Select Brand" searchPlaceholder="Search Brand..." />
          </>
        }
        { brandId &&
          <>
            <span style={{ color:"rgba(255,255,255,0.28)", fontSize:14, margin:"0 2px" }}>/</span>
            <BreadcrumbDropdown value={projectId} name={selectedProject} onChange={onChangeProject} options={projects} placeholder="Select Project" searchPlaceholder="Search Project..." />
          </>
        }
        { projectId &&
          <>
            <span style={{ color:"rgba(255,255,255,0.28)", fontSize:14, margin:"0 2px" }}>/</span>
            <BreadcrumbDropdown value={simulationId} name={selectedSimulation} onChange={onChangeSimulation} options={simulations} placeholder="Select Simulation" searchPlaceholder="Search Simulation..." />
          </>
        }
          </>
        )}
      </div>
      {(
        <div className={styles.headerRight}>
          {role !== 'super_admin' && creditUsed != null && creditIncluded != null && (
            <div className={styles.creditBalance}>
              {creditBalanceLoading
                ? 'Loading…'
                : creditTierUnlimited
                  ? 'Credit balance: Unlimited'
                  : `Credit balance ${creditUsed}/${creditIncluded + (creditTopup ?? 0)}`}
            </div>
          )}
          {role === 'super_admin' && (
            <span className={styles.hrole}>Super-admin</span>
          )}
          <div
            ref={userMenuRef}
            className={`${styles.userMenu} ${showUserMenu ? styles.userMenuOpen : ''}`}
          >
            <div className={styles.avatarButton} onClick={toggleUserMenu}>
              {userInitials}
            </div>
            {showUserMenu && (
              <div className={styles.userPop}>
                <div className={styles.userPopHead}>
                  <div className={styles.userPopAvatar}>{userInitials}</div>
                  <div>
                    <div className={styles.userPopName}>{userInfo?.fullName}</div>
                    <div className={styles.userPopEmail}>{userInfo?.email}</div>
                  </div>
                </div>
                <div className={styles.userPopDivider} />
                {role === 'super_admin' && (
                  <button type="button" className={styles.userPopItem} onClick={openAdmin}>
                    <ShieldCheck size={16} />
                    Admin
                    <span className={styles.userPopBadge}>Super</span>
                  </button>
                )}
                <button type="button" className={styles.userPopItem} onClick={openProfile}>
                  <UserCircle size={16} />
                  Account settings
                </button>
                <div className={styles.userPopDivider} />
                <button type="button" className={styles.userPopItem} onClick={handleLogout}>
                  <LogOut size={16} />
                  Sign out
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Header
